
import { Component, Vue, Prop } from 'vue-property-decorator';
import { UserModule } from '@/store/modules/user';

@Component({
  name: 'OrderNoticeDialog'
})
export default class extends Vue {
  @Prop({
    type: Boolean,
    default: false
  })
  noticeVisible!: Boolean;
   @Prop({
     type: Object,
     default: () => {}
   })
  noticeData!: any;

   private close() {
     if (parseInt(this.noticeData.serNum) === 1 && parseInt(this.noticeData.type) === 2) {
       this.$router.push('/Index');
     } else if (parseInt(this.noticeData.type) === 2) {
       this.$emit('close', false, true);
     } else {
       this.$emit('close', false, false);
     }
   }

   private showErrorMsg(msg: string) {
     this.$notify({
       title: '提示',
       message: msg,
       offset: 100,
       type: 'error'
     });
   }
}
